import {
  createRouter,
  createWebHistory
} from 'vue-router';
import routes from './router';
import { acessoUtils } from "../util/acesso.utils";
import { servidorUtils } from '../util/servidor.utils';
import { toastUtils } from '../util/toast.utils';
import { env } from '../env'
import { telemetriaService } from '../service/telemetria-service';

import { version } from '../../package.json';
import { Authenticator } from '../stateManagement/authenticator';
import { cookieUtils } from '../util/cookie.utils';
import { pessoaLogada } from '../stateManagement/pessoaLogada';
import { configuracoesStore } from '../stateManagement/configuracoes';

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach(async (to, from) => {
  if(servidorUtils.isServidorEmManutencao()) {
    router.push('/manutencao')
    return;
  }

  if (to.meta.openRoute) {
    return
  }

  const isAuthenticated = await Authenticator.getIsAuthenticated()
  if (!!!isAuthenticated) {
    window.location = `//${env.econtadorFront}`;
    return;
  }

  await configuracoesStore.carregarConfiguracoes();

  if (to.meta.pessoaLogadaRequired) {
    await pessoaLogada.atualizar()
  }

  const userConnection = await Authenticator.getUserConnection();
  if(to.meta.pilotoTarefasRequired && pessoaLogadaNaoEPilotoTarefas(userConnection)) {
    window.location = `//${env.econtadorFront}`;
    return;
  }

  if (to.meta.tarefasRequired && pessoaLogadaNaoTemTarefasWeb(userConnection)) {
    window.location = `//${env.econtadorFront}Publicidade/Etarefas?urlRedirect=${window.location.href}`;
    return;
  }
 
  if (isPessoaLogadaSemPermissaoParaAcessar(to.path)) {
    toastUtils.dangerToast('Você tentou acessar uma área que não tem acesso, por favor contate o administrador do sistema.')
    setTimeout(() => {
      window.location = `//${env.econtadorFront}`;
    }, 2000)
    return;
  }

  const crmDoUsuarioLogado = acessoUtils.adquirirCRMDoUsuarioLogado()
  let cookieVersaoConfigurada = `versao-configurada-tarefas-web-${crmDoUsuarioLogado}`;
  if (cookieUtils.verificarCookie(cookieVersaoConfigurada)) {
    let versao = cookieUtils.adquirirCookie(cookieVersaoConfigurada);

    if(versao == version) {
      return true;
    }
  }
  
  const configuracaoPendente = await acessoUtils.getConfiguracaoPendente();
  if (!acessoUtils.hasConfiguracaoPendente(configuracaoPendente)) {
    document.cookie = `${cookieVersaoConfigurada}=${version}`;
    return true;
  }

  const statusTela = "is-loading";
  document.dispatchEvent(
    new CustomEvent('trf-show-modal-configuracao-pendente', {
      detail: { isModalConfiguracaoPendenteActive: true, statusTela, configuracaoPendente },
      composed: true
    })
  );

  return true
})

router.afterEach((from) => {
  if (isFuncionalidadeMapeadaNoTelemetria(from.path)) {
    telemetriaService.cadastrarTelemetria(from.path);
  }
})

const isFuncionalidadeMapeadaNoTelemetria = (path) => {
  return path == "/minhas-tarefas" || path == "/dashboard" || path == "/cadastro-de-tarefas" || path == "/grupo-de-tarefas" || path == '/elegalize';
}

const pessoaLogadaNaoTemPermissaoDeVisualizarENaoESuperAdm = () => {
  return !pessoaLogada.hasPermissao("Tarefas", "Visualizar");
}

const pessoaLogadaTemPermissaoDeVisualizarEECliente = () => {
  return pessoaLogada.hasPermissao("Tarefas", "Visualizar")
    && !pessoaLogada?.current?.IsContador;
}

const pessoaLogadaNaoTemObjetoDePermissaoDoTarefasEECliente = () => {
  return !pessoaLogada?.current?.Permissoes?.Tarefas
    && !pessoaLogada?.current?.IsContador;
}

const pessoaLogadaIsCliente = () => {
  return !pessoaLogada?.current?.IsContador;
}

const pessoaLogadaNaoTemTarefasWeb = (userConnection) => {
  return !userConnection?.tareferWeb;
}

const pessoaLogadaNaoEPilotoTarefas = (userConnection) => {
  return !userConnection?.isPilotoTarefas;
}

const pessoaLogadaNaoTemPermissaoParaAcessarTemplatesTarefas = (path) => {
  return path == '/cadastro-de-modelos'
    && (
      !pessoaLogada?.current?.Administrador
      && !pessoaLogada.hasPermissao("AcessoTemplatesTarefas")
    );
}

const isPessoaLogadaSemPermissaoParaAcessar = (path) => {
  return pessoaLogadaIsCliente() || 
         pessoaLogadaNaoTemPermissaoDeVisualizarENaoESuperAdm() || 
         pessoaLogadaTemPermissaoDeVisualizarEECliente() || 
         pessoaLogadaNaoTemObjetoDePermissaoDoTarefasEECliente() || 
         pessoaLogadaNaoTemPermissaoParaAcessarTemplatesTarefas(path);
}

export default router;
